var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var tween = {
    duration: 300
};
var linearTween = __assign({}, tween, { easing: function (v) { return v; } });
var overDampedSpring = function (_a) {
    var toValue = _a.toValue;
    return ({
        type: 'spring',
        stiffness: 700,
        damping: toValue === 0 ? 100 : 35
    });
};
var underDampedSpring = {
    type: 'spring',
    stiffness: 500,
    damping: 25,
    restDelta: 0.5,
    restSpeed: 10
};
var intelligentTransition = {
    x: underDampedSpring,
    y: underDampedSpring,
    z: underDampedSpring,
    rotate: underDampedSpring,
    rotateX: underDampedSpring,
    rotateY: underDampedSpring,
    rotateZ: underDampedSpring,
    scaleX: overDampedSpring,
    scaleY: overDampedSpring,
    scaleZ: overDampedSpring,
    scale: overDampedSpring,
    opacity: linearTween,
    default: tween
};
export default new Map().set('default', intelligentTransition);
//# sourceMappingURL=default-transitions.js.map